import { Icon, Icons } from 'components/Icon';
import React from 'react';
import { PensionAccount } from 'service/dto/pension-account.dto';
import RSA from '../../../assets/assets/rsa.png';

type Props = {
  asset: PensionAccount;
  selectedAssetId?: number;
  handleShowDetails?: () => void;
};

export default function RSAAsset({
  asset,
  selectedAssetId,
  handleShowDetails
}: Props) {
  return (
    <>
      <div className="border-b border-[#E5E5E5]">
        <div className="flex items-center justify-between p-3 px-5">
          <span className="text-base font-normal text-[#34475E]">
            RSA Account
          </span>
          {handleShowDetails && (
            <button
              type="button"
              className={`cursor-pointer ${
                selectedAssetId === asset.id ? 'rotate-180' : ''
              }`}
              onClick={handleShowDetails}
            >
              <Icon name={Icons.ArrowDownCircle} />
            </button>
          )}
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-between px-4 pb-1">
        <div className="mr-3 space-y-2">
          <img src={RSA} className="h-[6.5rem] w-[6.5rem] object-contain" />
        </div>
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">RSA</div>
          <div className="text-xs text-slate-600 ">
            {asset.pensionAdministratorName}
          </div>
        </div>
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">
            Account Number
          </div>
          <div className="text-xs text-slate-600 ">{asset.pinNumber}</div>
        </div>
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">
            Account Type
          </div>
          <div className="text-xs text-slate-600 ">{asset.rsaAddress}</div>
        </div>
        <div className="my-2 mr-3 space-y-2">
          <div className="text-xs font-medium text-slate-600 ">
            Percentage Alloted
          </div>
          <div className="text-xs text-slate-600 ">
            {asset.percentageAlloted}%
          </div>
        </div>
        {asset.totalBeneficiary ? (
          <div className="my-2 mr-3 space-y-2">
            <div className="text-xs font-medium text-slate-600 ">
              Number of Beneficaries
            </div>
            <div className="text-xs text-slate-600 ">
              {asset.totalBeneficiary}
            </div>
          </div>
        ) : (
          <div className="my-2 mr-3 space-y-2">
            <div className="text-xs font-medium text-slate-600 ">
              Contributor Name
            </div>
            <div className="text-xs text-slate-600 ">
              {asset.contributorName}
            </div>
          </div>
        )}
        <div className="my-2 mr-3 space-y-2"></div>
      </div>
    </>
  );
}
